import { render, staticRenderFns } from "./ConsultationReports.vue?vue&type=template&id=6e931f0d&scoped=true&"
import script from "./ConsultationReports.vue?vue&type=script&lang=js&"
export * from "./ConsultationReports.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationReports.vue?vue&type=style&index=0&id=6e931f0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e931f0d",
  null
  
)

export default component.exports